import { render, staticRenderFns } from "./UploadAbstract.vue?vue&type=template&id=0f38ef15&scoped=true&"
import script from "./UploadAbstract.vue?vue&type=script&lang=js&"
export * from "./UploadAbstract.vue?vue&type=script&lang=js&"
import style0 from "./UploadAbstract.vue?vue&type=style&index=0&id=0f38ef15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f38ef15",
  null
  
)

export default component.exports